import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";

import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import LearnerGate from "@/pages/LearnerGate";

import CoachLayout from "@/components/CoachLayout";
import CoachDashboard from "@/pages/coach/Dashboard";
import Learners from "@/pages/coach/Learners";
import LearnerProfile from "@/pages/coach/LearnerProfile";
import SessionsIndex from "@/pages/coach/SessionsIndex";
import CoachSessionDetail from "@/pages/coach/SessionDetail";
import CoachMissions from "@/pages/coach/Missions";
import CoachResources from "@/pages/coach/Resources";
import CoachMessages from "@/pages/coach/Messages";
import CoachCalendar from "@/pages/coach/CalendarPage";

import LearnerLayout from "@/components/LearnerLayout";
import LearnerHome from "@/pages/learner/Home";
import LearnerSessions from "@/pages/learner/Sessions";
import LearnerSessionDetail from "@/pages/learner/SessionDetail";
import LearnerMissions from "@/pages/learner/Missions";
import LearnerResources from "@/pages/learner/Resources";
import LearnerCalendar from "@/pages/learner/CalendarPage";
import LearnerSubmissions from "@/pages/learner/Submissions";
import LearnerMessages from "@/pages/learner/Messages";

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/l/:token" element={<LearnerGate />} />

      <Route path="/coach" element={<CoachLayout />}>
        <Route index element={<CoachDashboard />} />
        <Route path="apprenants" element={<Learners />} />
        <Route path="apprenants/:id" element={<LearnerProfile />} />
        <Route path="seances" element={<SessionsIndex />} />
        <Route path="seances/:id" element={<CoachSessionDetail />} />
        <Route path="missions" element={<CoachMissions />} />
        <Route path="ressources" element={<CoachResources />} />
        <Route path="messagerie" element={<CoachMessages />} />
        <Route path="calendrier" element={<CoachCalendar />} />
      </Route>

      <Route path="/learner" element={<LearnerLayout />}>
        <Route index element={<LearnerHome />} />
        <Route path="seances" element={<LearnerSessions />} />
        <Route path="seances/:id" element={<LearnerSessionDetail />} />
        <Route path="missions" element={<LearnerMissions />} />
        <Route path="travaux" element={<LearnerSubmissions />} />
        <Route path="ressources" element={<LearnerResources />} />
        <Route path="messagerie" element={<LearnerMessages />} />
        <Route path="calendrier" element={<LearnerCalendar />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Router />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
